const booleanToText = expression => (expression ? 'Yes' : 'No')
const textToBoolean = expression => (expression !== null && expression !== undefined && expression.toLowerCase() === 'yes')

export {
  booleanToText,
  textToBoolean
}
